module.exports = __webpack_public_path__ + "static/media/icoSettings.6c919abd.svg";